const headPages = [
  {
    path: '/departments',
    title: 'Departments',
  },
];

export default headPages;
